// extracted by mini-css-extract-plugin
module.exports = {"root":"DebugPage__root__4CCLe","content":"DebugPage__content__X0MNZ","loggedCount":"DebugPage__loggedCount__6wnbb","label":"DebugPage__label__sVusB"};